(function () {
  function mainForm() {
    return document.querySelector('form[action*="/cart/add"][data-type="add-to-cart-form"]') ||
      document.querySelector('[id$="__main"] form[action*="/cart/add"]') ||
      document.querySelector('form[action*="/cart/add"]');
  }

  function scrollToBuyBox(target) {
    var el = target || document.querySelector('[id$="__main"]');
    if (!el) return;
    var top = el.getBoundingClientRect().top + window.pageYOffset - 120;
    window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
  }

  // Swatch click: select matching option in the theme's own variant picker, then scroll up.
  function selectColour(value) {
    var main = document.querySelector('[id$="__main"]') || document;
    var inputs = main.querySelectorAll('input[type="radio"]');
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].value === value) {
        var label = inputs[i].id ? main.querySelector('label[for="' + inputs[i].id + '"]') : null;
        (label || inputs[i]).click();
        return true;
      }
    }
    var selects = main.querySelectorAll('select');
    for (var j = 0; j < selects.length; j++) {
      for (var k = 0; k < selects[j].options.length; k++) {
        if (selects[j].options[k].value === value) {
          selects[j].value = value;
          selects[j].dispatchEvent(new Event('change', { bubbles: true }));
          return true;
        }
      }
    }
    return false;
  }

  function setQuantity(qty) {
    var form = mainForm();
    var scope = (form && form.closest('[id$="__main"]')) || document;
    var input = scope.querySelector('input[name="quantity"]') || document.querySelector('input[name="quantity"]');
    if (!input) return null;
    input.value = qty;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
    return input;
  }

  document.addEventListener('click', function (e) {
    var swatch = e.target.closest('[data-cv-swatch]');
    if (swatch) {
      var ok = selectColour(swatch.getAttribute('data-cv-swatch'));
      if (ok) {
        e.preventDefault();
        document.querySelectorAll('[data-cv-swatch]').forEach(function (s) { s.classList.toggle('is-active', s === swatch); });
        scrollToBuyBox();
      }
      return;
    }
    var qtyBtn = e.target.closest('[data-cv-qty]');
    if (qtyBtn) {
      e.preventDefault();
      var input = setQuantity(parseInt(qtyBtn.getAttribute('data-cv-qty'), 10) || 1);
      scrollToBuyBox(input || null);
      return;
    }
    var up = e.target.closest('[data-cv-scroll-up]');
    if (up) {
      e.preventDefault();
      scrollToBuyBox();
    }
  });

  // Lazy autoplay for ambient videos
  function initVideos(root) {
    var vids = (root || document).querySelectorAll('video[data-cv-src]');
    if (!vids.length) return;
    if (!('IntersectionObserver' in window)) {
      vids.forEach(function (v) { v.src = v.getAttribute('data-cv-src'); v.play && v.play().catch(function () {}); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var v = entry.target;
        if (entry.isIntersecting) {
          if (!v.getAttribute('src')) v.src = v.getAttribute('data-cv-src');
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else {
          v.pause();
        }
      });
    }, { threshold: 0.25 });
    vids.forEach(function (v) { io.observe(v); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initVideos(); });
  } else {
    initVideos();
  }
  document.addEventListener('shopify:section:load', function (e) { initVideos(e.target); });
})();
